import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

import AdminServices from "../../../services/AdminServices";
import CashFlowSummaryCard from "./CashFlowSummaryCard";
import CashEntryPendingModal from "../CashBook/CashEntryPendingModal";
import { CashAccountsWorkflow } from "../CashBook/CashEntryWorkflow";
import CashReturnedRejectedModal from "../CashBook/CashReturnedRejectedModal";

const getUserRole = () => {
  try {
    const user = JSON.parse(
      localStorage.getItem("userDetails")
    );

    return String(user?.data?.user?.role || "")
      .trim()
      .toLowerCase();
  } catch {
    return "";
  }
};

const getDashboardPayload = (response) =>
  response?.data?.data || response?.data || response || {};

const Home3 = ({ dashboardData }) => {
  const [showCashFlowModal, setShowCashFlowModal] =
    useState(false);

  const [showAmendmentModal, setShowAmendmentModal] =
    useState(false);
  const [cashActionKind, setCashActionKind] = useState(null);
  const [updatedDashboard, setUpdatedDashboard] = useState(null);

  const refreshCashDashboard = async () => {
    try {
      const response = await AdminServices.dashboard();
      setUpdatedDashboard(getDashboardPayload(response));
      setError("");
    } catch {
      setError(
        "Action completed, but dashboard counts could not refresh. Please refresh the page."
      );
    }
  };

  const [userRole] = useState(getUserRole);
  const [cashDashboard, setCashDashboard] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");



  const canViewCashFlow = [
    "cashmaker",
    "cashchecker",
    "accounts"
  ].includes(userRole);

  const hasParentData = dashboardData !== undefined;

  useEffect(() => {
    if (!canViewCashFlow || hasParentData) return;

    let active = true;

    setLoading(true);
    setError("");

    AdminServices.dashboard()
      .then((response) => {
        if (active) {
          setCashDashboard(getDashboardPayload(response));
        }
      })
      .catch(() => {
        if (active) {
          setError("Unable to load cash approval counts.");
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [canViewCashFlow, hasParentData, userRole]);

  const openAmendmentModal = () => {
    if (!canViewCashFlow) return;

    setShowAmendmentModal(true);
  };

  const closeAmendmentModal = () => {
    setShowAmendmentModal(false);
  };

  if (!canViewCashFlow) return null;

  return (
    <>
      <div className="row">
        <div className="col-xl-12">
          {error && (
            <div className="alert alert-danger py-2">
              {error}
            </div>
          )}

          <CashFlowSummaryCard
            data={
              updatedDashboard ??
              (hasParentData ? dashboardData : cashDashboard)
            }
            loading={loading}
            userRole={userRole}
            onClick={() => setShowCashFlowModal(true)}
            onAmendmentClick={openAmendmentModal}
            onReturnedClick={() => setCashActionKind("returned")}
            onRejectedClick={() => setCashActionKind("rejected")}
          />
        </div>
      </div>

      <CashEntryPendingModal
        show={showCashFlowModal}
        handleClose={() => setShowCashFlowModal(false)}
        userRole={userRole}
      />
      {cashActionKind && (
        <CashReturnedRejectedModal
          show
          kind={cashActionKind}
          userRole={userRole}
          onHide={() => setCashActionKind(null)}
          onChanged={refreshCashDashboard}
        />
      )}

      {canViewCashFlow && showAmendmentModal && (
        <Modal
          show
          onHide={closeAmendmentModal}
          size="xl"
          fullscreen="lg-down"
          scrollable
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Cash Amendments &amp; Date Access
            </Modal.Title>
          </Modal.Header>

          <Modal.Body className="erp-compact">
            <CashAccountsWorkflow standalone />
          </Modal.Body>

          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeAmendmentModal}
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};

export default Home3;